import { create } from 'zustand';

import { settingsApi } from '@/lib/api/settings.api';

interface BrandingState {
  companyName: string;
  websiteUrl: string;
  logoUrl: string;
  logoUrlDark: string;
  faviconUrl: string;
  primaryColor: string;
  primaryColorDark: string;
  isLoaded: boolean;
  loadBranding: () => Promise<void>;
}

export const useBrandingStore = create<BrandingState>()((set) => ({
  companyName: '',
  websiteUrl: '',
  logoUrl: '',
  logoUrlDark: '',
  faviconUrl: '',
  primaryColor: '',
  primaryColorDark: '',
  isLoaded: false,

  loadBranding: async () => {
    try {
      const branding = await settingsApi.getBranding();

      set({
        companyName: branding.COMPANY_NAME || '',
        websiteUrl: branding.COMPANY_WEBSITE || '',
        logoUrl: branding.COMPANY_LOGO_URL || '',
        logoUrlDark: branding.COMPANY_LOGO_DARK || '',
        faviconUrl: branding.CLIENT_FAVICON_URL || '',
        primaryColor: branding.CLIENT_PRIMARY_COLOR || '',
        primaryColorDark: branding.CLIENT_PRIMARY_COLOR_DARK || '',
        isLoaded: true,
      });
    } catch {
      // Branding fetch is non-critical — keep defaults
      set({ isLoaded: true });
    }
  },
}));
